import { api } from '@/lib/api-client';

import { tokenSchema } from '../types/token';

const getLocalStorageToken = (): string => {
  const unparsedToken = localStorage.getItem('token');

  if (!unparsedToken) {
    throw new Error('No token present.');
  }

  const parsedToken = JSON.parse(unparsedToken);
  const token = tokenSchema.parse(parsedToken);

  // Ex: Bearer <JWT>.
  return `Bearer ${token.accessToken}`;
};

export const getTokenValidity = async (): Promise<boolean> => {
  let token: string;
  try {
    token = getLocalStorageToken();
  } catch {
    throw new Error('No valid token available.');
  }

  try {
    const response = await api.post(
      '/token/validate',
      {},
      {
        headers: { Authorization: token },
      },
    );

    return response.status === 204;
  } catch {
    throw new Error('Network error during token validation.');
  }
};
